<template>
	<div class="register">
		<backgroundone v-slot:backgroundslot>
			<registeritem>
				
			</registeritem>
		</backgroundone>
	</div>
</template>

<script>
	import backgroundone from '../components/background/backgroundone.vue'
	import registeritem from '../components/registerbox/registeritem.vue'
	export default {
	  name: 'Register',
		components:{
			backgroundone,
			registeritem
		}
	}
</script>

<style>
</style>
